import React from "react";
import HolidayCalenders from "../../components/StaffTabs/HolidayCalender/HolidayCalenders";

const HolidayCalender = () => {
  return (
    <div>
      
      <HolidayCalenders/>
    </div>
  );
};

export default HolidayCalender;
